module.exports = __webpack_public_path__ + "static/img/9.028bab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/xiaomi/9.png
// module id = OdAm
// module chunks = 0